export const parseCssTransformRule = (transform: string): { [key: string]: string } => {
    const extractedValues: { [key: string]: string } = {}

    Array.from(transform.matchAll(/(\w+)\((.+?)\)/gm)).forEach(([_, property, value]) => {
        extractedValues[property] = value
    })
    return extractedValues
}
